import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './AdminSidebar.css';

function AdminSidebar({ userRole, isOpen, onClose }) {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      path: '/admin/dashboard',
      label: 'Dashboard',
      icon: '📊',
      roles: ['admin', 'superadmin']
    },
    {
      path: '/admin/users',
      label: 'User Management',
      icon: '👥',
      roles: ['admin', 'superadmin']
    },
    {
      path: '/admin/logs',
      label: 'System Logs',
      icon: '📋',
      roles: ['admin', 'superadmin']
    },
    {
      path: '/admin/admins',
      label: 'Admin Users',
      icon: '👑',
      roles: ['superadmin']
    },
    {
      path: '/admin/qdrant',
      label: 'Knowledge Base',
      icon: '📚',
      roles: ['superadmin']
    },
    {
      path: '/admin/settings/agents',
      label: 'Agent Settings',
      icon: '🤖',
      roles: ['superadmin']
    },
    {
      path: '/admin/settings/system',
      label: 'System Settings',
      icon: '⚙️',
      roles: ['superadmin']
    },
    {
      path: '/admin/settings/api-keys',
      label: 'API Keys',
      icon: '🔑',
      roles: ['superadmin']
    },
    {
      path: '/admin/publication-slots',
      label: 'Publication Slots',
      icon: '🗓️',
      roles: ['admin', 'superadmin']
    },
    {
      path: '/admin/social-accounts',
      label: 'Social Accounts',
      icon: '📱',
      roles: ['admin', 'superadmin']
    },
    {
      path: '/admin/scheduled-videos',
      label: 'Scheduled Videos',
      icon: '🎬',
      roles: ['admin', 'superadmin']
    },
    {
      path: '/admin/test-publish',
      label: 'Test Publish',
      icon: '🧪',
      roles: ['superadmin']
    },
    {
      path: '/admin/test-publish/manual',
      label: 'Manual Test Publish',
      icon: '🛠️',
      roles: ['superadmin']
    },
    {
      path: '/admin/backups',
      label: 'Database Backups',
      icon: '💾',
      roles: ['superadmin']
    },
    {
      path: '/admin/alerts',
      label: 'System Alerts',
      icon: '🚨',
      roles: ['superadmin']
    },
    {
      path: '/admin/orphan-comments',
      label: 'Orphan Comments',
      icon: '🧹',
      roles: ['superadmin']
    },
    {
      path: '/admin/monitoring',
      label: 'Monitoring',
      icon: '🛰️',
      roles: ['admin', 'superadmin']
    },
    {
      path: '/admin/monitoring/conversations',
      label: 'Conversations',
      icon: '💬',
      roles: ['admin', 'superadmin']
    }
  ];

  const filteredItems = menuItems.filter(item => item.roles.includes(userRole));

  const handleNavClick = (path) => {
    navigate(path);
    if (window.innerWidth <= 768) {
      onClose();
    }
  };

  const handleKeyDown = (e, path) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleNavClick(path);
    }
  };

  return (
    <aside 
      id="admin-sidebar"
      className={`admin-sidebar ${isOpen ? 'open' : 'closed'}`}
      aria-label="Admin navigation sidebar"
    >
      <div className="sidebar-header">
        <h2>Admin Panel</h2>
      </div>
      <nav className="sidebar-nav" aria-label="Main navigation">
        {filteredItems.map((item, index) => (
          <button
            key={item.path}
            className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            onClick={() => handleNavClick(item.path)}
            onKeyDown={(e) => handleKeyDown(e, item.path)}
            aria-label={`Navigate to ${item.label}`}
            aria-current={location.pathname === item.path ? 'page' : undefined}
            tabIndex={isOpen ? 0 : -1}
          >
            <span className="nav-icon" aria-hidden="true">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
          </button>
        ))}
      </nav>
    </aside>
  );
}

export default AdminSidebar;

